function ConnectorIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.0677 18.152C9.05486 19.2888 6.40344 20 2.5 20C1.94772 20 1.5 19.5523 1.5 19C1.5 18.4477 1.94772 18 2.5 18C6.1547 18 8.44514 17.3362 10.0842 16.4105C11.7253 15.4837 12.7982 14.2534 13.9974 12.8782L14.0283 12.8427C15.2255 11.47 16.5462 9.96626 18.6197 8.84001C20.7023 7.70887 23.4574 7 27.5 7C28.0523 7 28.5 7.44772 28.5 8C28.5 8.55228 28.0523 9 27.5 9C23.6938 9 21.289 9.66613 19.5743 10.5975C17.8506 11.5337 16.7367 12.78 15.5356 14.1573C15.5035 14.1941 15.4714 14.231 15.4391 14.268C14.2791 15.599 13.0103 17.0548 11.0677 18.152Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.0677 13.848C9.05486 12.7112 6.40344 12 2.5 12C1.94772 12 1.5 12.4477 1.5 13C1.5 13.5523 1.94772 14 2.5 14C6.1547 14 8.44514 14.6638 10.0842 15.5895C11.7253 16.5163 12.7982 17.7466 13.9974 19.1218L14.0283 19.1573C15.2255 20.53 16.5462 22.0337 18.6197 23.16C20.7023 24.2911 23.4574 25 27.5 25C28.0523 25 28.5 24.5523 28.5 24C28.5 23.4477 28.0523 23 27.5 23C23.6938 23 21.289 22.3339 19.5743 21.4025C17.8506 20.4663 16.7367 19.22 15.5356 17.8427C15.5035 17.8059 15.4714 17.769 15.4391 17.732C14.2791 16.401 13.0103 14.9452 11.0677 13.848Z'
          fill='currentColor'
        />
        <path
          d='M29.8913 7.54278C30.7029 7.96821 30.7029 9.03179 29.8913 9.45722L25.3261 11.8503C24.5145 12.2757 23.5 11.7439 23.5 10.893L23.5 6.10695C23.5 5.25609 24.5145 4.7243 25.3261 5.14973L29.8913 7.54278Z'
          fill='currentColor'
        />
        <path
          d='M29.8913 24.4572C30.7029 24.0318 30.7029 22.9682 29.8913 22.5428L25.3261 20.1497C24.5145 19.7243 23.5 20.2561 23.5 21.107L23.5 25.8931C23.5 26.7439 24.5145 27.2757 25.3261 26.8503L29.8913 24.4572Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default ConnectorIcon;
